import React, { useEffect, useState ,useContext} from "react";
import InputField from "../../../lib/ui/inputs/Input";
import { Button } from "@material-ui/core";
import { LangCtx } from "../../../lib/context";
import { validateEmail, validateServerAddress, validatePortNumber } from '../../../../src/lib/validation.js';
import { createSmtpMsg, getSmtpData, updateSmtpMsg } from "../../../../src/actions/configuration";
import { toast } from 'react-toastify';
// import { PayLoadCtx } from '../../../../src/lib/context.js';
import Loader from '../../../lib/ui/loader/Loader.js';

const SMTP = () => {
    const [smsSave, setSmsSave] = useState(false);
    const [initialFormData, setInitialFormData] = useState({
        email: '',
        password: '',
        name: '',
        serverAddress: '',
        portNumber: ''
    });
    const [formData, setFormData] = useState(initialFormData);
    const [error, setError] = useState({});
    const [errorMsg, setErrorMsg] = useState(null);
    const [loading, setLoading] = useState(false);
    const [smtpData, setSmtpData] = useState();
    const { l } = useContext(LangCtx);
    // const { payload } = useContext(PayLoadCtx);


    const validateForm = () => {
        let _error = {};
        let returnValue = true;
        if (formData.serverAddress === '' || formData.serverAddress === null) {
            _error['serverAddress'] = "Please enter a server address";
            returnValue = false;
        } else if (!validateServerAddress(formData.serverAddress)) {
            _error['serverAddress'] = "Please enter a valid server address (e.g., smtp.example.com)";
            returnValue = false;
        }
        if (formData.portNumber === '' || formData.portNumber === null) {
            _error['portNumber'] = "Please enter a port number";
            returnValue = false;
        } else if (!validatePortNumber(formData.portNumber)) {
            _error['portNumber'] = "Please enter a valid port number (e.g., 25, 80, 443)";
            returnValue = false;
        }
        if (formData.name === '' || formData.name === null) {
            _error['name'] = "please enter your name"
            returnValue = false;
        }
        // else if (!validateConfigName(formData.name)) {
        //     _error['name'] = "please enter valid user name";
        //     returnValue = false;
        // }
        if (formData.password === '' || formData.password === null) {
            _error['password'] = "please enter password"
            returnValue = false;
        }
        // else if (!validatePassword(formData.password)) {
        //     _error['password'] = "please enter strong password";
        //     returnValue = false;
        // }
        if (formData.email === '' || formData.email === null) {
            _error['email'] = "Please enter email"
            returnValue = false
        }
        else if (!validateEmail(formData.email)) {
            _error['email'] = "please check the email you entered!!!!"
            returnValue = false
        }
        console.log('error in the textfields', _error, returnValue);
        setError(_error);
        return returnValue;
    }
    const smtpDataGetting = () =>{
        getSmtpData().then((res) => {
            const responseData = res?.data || null;
            setSmtpData(responseData);
            console.log("sms data", res);
            const initialData = {
                email: res?.data?.fromEmail || '',
                password: res?.data?.password || '',
                name: res?.data?.username || '',
                serverAddress: res?.data?.host || '',
                portNumber: res?.data?.port || ''
            }
            setFormData(initialData);
            setInitialFormData(initialData);
            setSmsSave(!!responseData);
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setSmsSave(false);
            setSmtpData();
            setLoading(false);
        })
    }
    useEffect(() => {
        setLoading(true);
        smtpDataGetting();
    }, []);
    const handleInputChange = (field) => (e) => {
        setFormData({
            ...formData,
            [field]: e.target.value,
        });
        setError((prevError) => ({
            ...prevError,
            [field]: '' 
        }));
    };
    const handleCancel = () => {
        if (initialFormData && Object.values(initialFormData).some(value => value !== "")) {
            setFormData(initialFormData);
            setError({}); 
            setSmsSave(true);
        } else {
            setFormData({ email: "", name: "", password:"", portNumber: "", serverAddress: "" });
            setError({});
            setSmsSave(false);
        }
    };
    const handleSmtp = (action) => {
        setLoading(true);
        try {
            if (validateForm()) {
                if (action === "Edit") {
                    setSmsSave(false);
                    setLoading(false);
                }
                else if (action === "Save") {
                    let body = {
                        host: formData.serverAddress,
                        port: formData.portNumber,
                        secure: true,
                        username: formData.name,
                        password: formData.password,
                        fromEmail: formData.email
                    }
                    if (smtpData) {
                        updateSmtpMsg(body).then((res) => {
                            setSmsSave(true);
                            smtpDataGetting();
                            setLoading(false);
                        }).catch((err) => {
                            console.log(err);
                            setSmsSave(false);
                            setLoading(false);
                        })
                    }
                    else {
                        createSmtpMsg(body).then((res) => {
                            setSmsSave(true);
                            setLoading(false);
                        }).catch((err) => {
                            setLoading(false);
                            setSmsSave(false);
                            console.log("errrrrrrrr", err)
                        })
                    }
                }

            }
            else {
                setLoading(false);
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            }

        } catch (err) {
            setLoading(false);
            toast.error(err.errorMessage, {
                position: toast.POSITION.TOP_RIGHT
            });
            console.log("Error", err);
            setErrorMsg("something went wrong please try again later");
        }
    }
    // console.log("==============",formData.email,formData.serverAddress,formData.portNumber,formData.name,formData.email,formData.password);
    return (
        <div className="colBlock nopdng pos-rel">
            {loading && <Loader />}
            <div className="formCol">
                <div className="formListGroup">
                    <form onSubmit={handleSmtp}>
                        <small className="inpLabel">
                            {l.smtp_serveraddr}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${smsSave ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder='e.g., smtp.example.com'
                                onChange={handleInputChange('serverAddress')}
                                type="text"
                                value={formData?.serverAddress}
                                error={error && error?.serverAddress}
                                errorMsg={error?.serverAddress}
                                disabled={smsSave}

                            />
                            {/* {error.serverAddress && <span className="redTxt">{error.serverAddress}</span>} */}
                        </div>
                        <small className="inpLabel">
                            {l.smtp_portnum}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${smsSave ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.smtp_phone}
                                onChange={handleInputChange('portNumber')}
                                type="text"
                                value={formData?.portNumber}
                                error={error && error?.portNumber}
                                errorMsg={error.portNumber}
                                disabled={smsSave}
                            />
                            {/* {error.portNumber && <span className="redTxt">{error.portNumber}</span>} */}
                        </div>
                        {/*  */}
                        <small className="inpLabel">
                            {l.smtp_username}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${smsSave ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.smtp_username}
                                onChange={handleInputChange('name')}
                                type="text"
                                value={formData?.name}
                                error={error && error?.name}
                                errorMsg={error?.name}
                                disabled={smsSave}
                            />
                            {/* {error.name && <span className="redTxt">{error.name}</span>} */}
                        </div>
                        <small className="inpLabel">
                            {l.smtp_password}
                        </small>
                        <div className={`inputRowFeild ${smsSave ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.smtp_password}
                                onChange={handleInputChange('password')}
                                value={formData?.password}
                                type="text"
                                error={error && error?.password}
                                errorMsg={error?.password}
                                disabled={smsSave}

                            />
                            {/* {error.password && <span className="redTxt">{error.password}</span>} */}
                        </div>
                        <small className="inpLabel">
                            {l.smtp_fromAddr}
                            <span className="redTxt">*</span>:
                        </small>
                        <div className={`inputRowFeild ${smsSave ? "disabledStripeInput" : ""}`}>
                            <InputField
                                placeholder={l.label_email}
                                onChange={handleInputChange('email')}
                                value={formData?.email}
                                type="email"
                                error={error && error?.email}
                                errorMsg={error?.email}
                                maxLength="30"
                                disabled={smsSave}

                            />
                            {/* {error.email && <span className="redTxt">{error.email}</span>} */}
                        </div>
                        <div className="crdBtnContainer justfiyEnd">
                            {!smsSave && <div className="flexInline pdngHSM capitalTxt">
                                <Button variant='outlined' color="primary" onClick={handleCancel}>
                                    {l.cancel}
                                </Button>
                            </div>}
                            {smsSave ? <Button variant="contained" color="primary" className="whiteTxt capitalTxt" onClick={() => handleSmtp("Edit")}>
                                {l.edit}
                            </Button> : <Button variant="contained" color="primary" className="whiteTxt capitalTxt" onClick={() => handleSmtp("Save")}>
                                {l.save}
                            </Button>}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SMTP;
